import { Box, Button, Text } from "components/ui";
import { router } from "expo-router";
import { Formik } from "formik";
import React, { useState } from "react";
import { ActivityIndicator } from "react-native";
import { usePostUserMutation, usePutUserByIdMutation, User } from "store/abcoApi";
import * as Yup from "yup";
import FormField from "./FormField";

interface UserFormProps {
	user?: User | null | undefined;
	isNew?: boolean;
	closePopupModal?: () => void;
}

export default function UserForm({ user = null, isNew = true, closePopupModal }: UserFormProps) {
	const validationSchema = Yup.object().shape({
		firstName: Yup.string().required("First name is required").min(2, "First name must be at least 2 characters"),
		lastName: Yup.string().required("Last name is required").min(2, "Last name must be at least 2 characters"),
		email: Yup.string().required("Email is required").email("Invalid email format"),
	});

	const [putUser] = usePutUserByIdMutation();
	const [postUser] = usePostUserMutation();
	const [isSubmitting, setIsSubmitting] = useState(false);

	return (
		<Box>
			<Formik
				initialValues={{
					firstName: user?.firstName ?? "",
					lastName: user?.lastName ?? "",
					email: user?.email ?? "",
				}}
				validationSchema={validationSchema}
				onSubmit={async (values) => {
					setIsSubmitting(true);
					try {
						if (!user?.id) {
							const createdUser = await postUser({
								user: {
									...values,
								},
							}).unwrap();

							if (closePopupModal) {
								closePopupModal();
							}
							router.push(`/admin/users/${createdUser.id}`);
						} else {
							await putUser({
								id: user.id,
								user: {
									...values,
								},
							}).unwrap();

							if (closePopupModal) {
								closePopupModal();
							}
						}
					} catch (error) {
						console.error("Error saving user:", error);
					} finally {
						setIsSubmitting(false);
					}
				}}
			>
				{(formik) => (
					<Box gap={20}>
						<Box gap={12}>
							<FormField label="First Name" name="firstName" placeholder="Enter first name" formik={formik} />
							<FormField label="Last Name" name="lastName" placeholder="Enter last name" formik={formik} />
							<FormField label="Email" name="email" placeholder="Enter email" formik={formik} />
						</Box>

						<Button width={120} variant="secondary" onPress={() => formik.handleSubmit()} disabled={formik.isSubmitting}>
							<Text>{isNew ? "Create" : "Update"}</Text>
							{isSubmitting && <ActivityIndicator size="small" style={{ position: "absolute", right: 12 }} />}
						</Button>
					</Box>
				)}
			</Formik>
		</Box>
	);
}
